<template>
  <div class="template">
    <div class="text-center py-12">
      <h1
        class="text-3xl text-center font-extrabold text-gray-700 mb-10 tracking-tight title-underline uppercase"
      >
        SILICONE RUBBER PRODUCTS
      </h1>
    </div>
    <section class="py-4">
      <div class="container mx-auto px-6 max-w-5xl">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-16">
          <div
            v-for="(item, index) in categories"
            :key="'app-' + index"
            class="group cursor-pointer"
          >
            <div
              class="aspect-square bg-slate-50 dark:bg-slate-800 rounded-2xl p-6 mb-4 flex items-center justify-center overflow-hidden"
              @click="onItemClick(index)"
            >
              <img
                :alt="item.msg"
                class="w-full h-full object-contain"
                :src="item.img"
              />
            </div>
            <h3
              class="text-xl font-bold text-center text-slate-800 dark:text-slate-200 line-clamp-2"
            >
              {{ item.msg }}
            </h3>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Categories',
  components: {},
  data() {
    return {
      categories: [
        {
          img: require('@/assets/product/CA-HTV.jpg'),
          msg: 'HCR'
        },

        {
          img: require('@/assets/product/CA-LSR.jpg'),
          msg: 'LSR'
        }
      ]
    }
  },
  methods: {
    onItemClick(index) {
      this.$emit('categoryClick', this.categories[index])
    }
  }
}
</script>

<style scoped>
.title-underline {
  position: relative;
  display: inline-block;
}
.title-underline::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 8px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 20" preserveAspectRatio="none"><path d="M0 15 Q 25 5, 50 15 T 100 15" stroke="%23004494" stroke-width="4" fill="transparent"/></svg>');
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/Products/Categories.vue